import { db, uid } from './db';
import { DEFAULT_BYOK_MODEL } from './models';
import { makePoster } from './poster';
import { extractTitle } from './analyze';

export const DEFAULT_SETTINGS = {
  aiMode: 'byok',
  universalModel: 'claude-opus-5-5',
  byokModel: DEFAULT_BYOK_MODEL,
  apiKey: '',
  fps: 60,
  master: 0.8,
  sfx: 0.8,
  music: 0.35,
  bpm: 120,
  musicOn: false,
  haptics: true,
  showPad: 'auto',
  autoLockMin: 0,
  orientation: 'auto',
};

export const UNIVERSAL_MODELS = [
  { id: 'claude-opus-5-5', label: 'Claude Opus 5.5', note: 'Massima qualità di codice' },
  { id: 'claude-sonnet-5-5', label: 'Claude Sonnet 5.5', note: 'Bilanciato' },
  { id: 'claude-haiku-5-5', label: 'Claude Haiku 5.5', note: 'Veloce ed economico' },
  { id: 'claude-fable-5-1', label: 'Claude Fable 5.1', note: 'Avanzato, più lento' },
  { id: 'gpt-6-luna', label: 'GPT 6 Luna', note: 'Alternativa OpenAI' },
];
export { BYOK_MODELS } from './models';

export function newVersion(code, label, prompt, parentId = null) {
  return { id: uid(), parentId, label, prompt: prompt || '', code, createdAt: Date.now() };
}

export async function createGame({ title, genre = 'Arcade', code, label = 'Genesi', cover = null, blank = false }) {
  const v = newVersion(code, label, '');
  const g = {
    id: uid(), title: title || extractTitle(code), genre, code, cover: cover || (await makePoster({ title: title || extractTitle(code), genre })), blank,
    createdAt: Date.now(), updatedAt: Date.now(), playTime: 0, scores: [], chat: [], versions: [v], headId: v.id,
  };
  await db.putGame(g);
  return g;
}

export async function saveGame(g) {
  const next = { ...g, updatedAt: Date.now() };
  await db.putGame(next);
  return next;
}

export function commit(g, code, label, prompt) {
  const v = newVersion(code, label, prompt, g.headId);
  return { ...g, code, versions: [...g.versions, v], headId: v.id };
}

export function checkout(g, vid) {
  const v = g.versions.find((x) => x.id === vid);
  return v ? { ...g, code: v.code, headId: vid } : g;
}

export function addScore(g, value) {
  const scores = [...(g.scores || []), { value, date: Date.now() }].sort((a, b) => b.value - a.value).slice(0, 10);
  return { ...g, scores };
}

const DEMOS = [
  { file: 'neon-drift.html', title: 'Neon Drift', genre: 'Shoot \'em up' },
  { file: 'pixel-leap.html', title: 'Pixel Leap', genre: 'Platform' },
  { file: 'void-flap.html', title: 'Void Flap', genre: 'One-Tap' },
];

const DEMO_VERSION = 3;
const DEMO_LABEL = 'Demo v3: standard commerciale';

export async function seedDemos() {
  const seeded = await db.kvGet('seeded');
  if (seeded >= DEMO_VERSION) return;
  if (seeded) {
    const all = await db.allGames();
    for (const d of DEMOS) {
      const g = all.find((x) => x.title === d.title && x.versions?.some((v) => v.label === 'Demo originale'));
      // update only untouched demos; the previous code stays in the version history
      if (!g || !g.versions[g.versions.length - 1]?.label?.startsWith('Demo')) continue;
      const code = await (await fetch(`/demos/${d.file}`)).text();
      await db.putGame({ ...commit(g, code, DEMO_LABEL, 'Aggiornamento TITAN'), updatedAt: Date.now() });
    }
    await db.kvSet('seeded', DEMO_VERSION);
    return;
  }
  for (const d of DEMOS) {
    const code = await (await fetch(`/demos/${d.file}`)).text();
    await createGame({ title: d.title, genre: d.genre, code, label: 'Demo originale' });
  }
  await db.kvSet('seeded', DEMO_VERSION);
}

export function fmtTime(sec = 0) {
  const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60);
  return h ? `${h}h ${m}m` : `${m}m ${Math.floor(sec % 60)}s`;
}
